import React from 'react';
import PropTypes from 'prop-types';
import QRCode from 'react-qr-code';

const QRCodeGenerator = React.memo(({ qrText }) => (
  <>
    {qrText && qrText.length > 0 && <QRCode value={qrText} />}
  </>
));

QRCodeGenerator.propTypes = {
  qrText: PropTypes.string.isRequired,
};

export default QRCodeGenerator;
